import React from "react"
import PreviewPopover from './PreviewPopover'
import ReactDOM from 'react-dom';


class HiddenPreviewPopover extends React.Component{
  constructor(props){
    super(props);
  };

  componentDidMount(){
    $(`#popover-wrapper-${this.props.targetId}`).popover({
      content: `<div id="popover-${this.props.targetId}"></div>`,
      html: true,
      placement: this.props.position || 'auto',
      offset: '-200px, -200px, 0px, 0px',
    }).data('bs.popover')
    // .addClass(this.props.classes ? this.props.classes : '')
      // .tip()

    $(`#popover-wrapper-${this.props.targetId}`).on('click', function(e){
      e.preventDefault()
    })
   $('body').on('click', function (e) {
      $('[data-toggle=popover]').each(function (idx, node) {
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
          $(this).popover('hide');
        };
      });
    });

    $(`#popover-wrapper-${this.props.targetId}`).on('shown.bs.popover', () => {
      ReactDOM.render(<PreviewPopover {...this.props} />, $(`#popover-${this.props.targetId}`)[0])
    });
  };

  componentDidUpdate(prevProps, prevState){
    if ($(`#popover-${this.props.targetId}`).closest('.popover').hasClass('show')){
      ReactDOM.render(<PreviewPopover {...this.props} />, $(`#popover-${this.props.targetId}`)[0])
    };
  };

  render(){
    return(
     null
    );
  };

};

export default HiddenPreviewPopover